import React, { useEffect, useRef, useState } from 'react';
import { motion, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const [isHovering, setIsHovering] = useState(false);
  const isHoveringRef = useRef(false);
  const frameRef = useRef(null);
  const lastPointRef = useRef({ x: 0, y: 0, target: null });

  const cursorX = useSpring(0, { stiffness: 1000, damping: 28, mass: 0.1 });
  const cursorY = useSpring(0, { stiffness: 1000, damping: 28, mass: 0.1 });
  
  const ringX = useSpring(0, { stiffness: 150, damping: 15, mass: 0.6 });
  const ringY = useSpring(0, { stiffness: 150, damping: 15, mass: 0.6 });

  useEffect(() => {
    const syncCursor = () => {
      frameRef.current = null;
      const { x, y, target } = lastPointRef.current;
      const isMagnetic = Boolean(target?.closest?.('a, button'));

      if (isHoveringRef.current !== isMagnetic) {
        isHoveringRef.current = isMagnetic;
        setIsHovering(isMagnetic);
      }

      cursorX.set(x - 6);
      cursorY.set(y - 6);
      
      if (isMagnetic) {
        ringX.set(x - 24);
        ringY.set(y - 24);
      } else {
        ringX.set(x - 20);
        ringY.set(y - 20);
      }
    };

    const updateMousePosition = (e) => {
      lastPointRef.current = { x: e.clientX, y: e.clientY, target: e.target };
      if (!frameRef.current) {
        frameRef.current = window.requestAnimationFrame(syncCursor);
      }
    };

    window.addEventListener("mousemove", updateMousePosition);
    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
      if (frameRef.current) {
        window.cancelAnimationFrame(frameRef.current);
      }
    };
  }, [cursorX, cursorY, ringX, ringY]);

  return (
    <div className="pointer-events-none z-[9999]">
      <motion.div className="fixed top-0 left-0 w-3 h-3 bg-neon-cyan rounded-full shadow-[0_0_10px_#00f3ff] pointer-events-none" style={{ x: cursorX, y: cursorY }} />
      <motion.div className={`fixed top-0 left-0 border rounded-full pointer-events-none transition-all duration-300 ${isHovering ? 'w-12 h-12 border-neon-cyan bg-neon-cyan/20 shadow-neon' : 'w-10 h-10 border-neon-purple/70 shadow-[0_0_15px_rgba(188,19,254,0.3)]'}`} style={{ x: ringX, y: ringY }} />
    </div>
  );
}
